/**
 * Verification API — submit expert/company verification requests.
 */

import { supabase } from '@turnifly/shared/api'

export interface VerificationRequestParams {
  userId: string
  type: 'expert' | 'organization' | 'company'
  displayName: string
  username: string
  website?: string
  documentsUrls: string[]
  contactPhone?: string
  contactTelegram?: string
}

export async function submitVerificationRequest(
  params: VerificationRequestParams,
): Promise<unknown> {
  const { data } = await supabase
    .from('verification_requests')
    .insert({
      user_id: params.userId,
      type: params.type,
      display_name: params.displayName,
      username: params.username,
      website: params.website ?? null,
      documents_urls: params.documentsUrls,
      contact_phone: params.contactPhone ?? null,
      contact_telegram: params.contactTelegram ?? null,
      status: 'pending',
    })
    .select()
    .single()
    .throwOnError()
  return data
}

export interface VerificationStatus {
  id: string
  type: string
  status: 'pending' | 'approved' | 'rejected'
  admin_notes: string | null
  created_at: string
  reviewed_at: string | null
}

export async function fetchVerificationStatus(
  userId: string,
): Promise<VerificationStatus | null> {
  const { data } = await supabase
    .from('verification_requests')
    .select('id, type, status, admin_notes, created_at, reviewed_at')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle()
    .throwOnError()
  return data as VerificationStatus | null
}
